/** This is a second action bar that appears below extra long journal/lit content */
import React, { useState, useRef, useLayoutEffect } from 'react';
import ActionBar from '..';
import { ActionBarContext, SecondaryActionBarContext, } from '../ActionBarContext';
import PanelPopup from '../../DeviationPage/_partials/PanelPopup';
import s from './SecondaryActionBar.scss';
var SecondaryActionBar = function (_a) {
    var children = _a.children, wrapperClassName = _a.wrapperClassName, deviation = _a.deviation;
    var anchorRef = useRef(null);
    var topBarRef = useRef(null);
    var _b = useState(false), showSecondaryActionBar = _b[0], setShowSecondaryActionBar = _b[1];
    // eslint-disable-next-line react-hooks/exhaustive-deps
    useLayoutEffect(function () {
        var content = topBarRef.current;
        var anchor = anchorRef && anchorRef.current;
        if (!content || !anchor || typeof window === 'undefined') {
            return;
        }
        var top = content.getBoundingClientRect().top;
        var bottom = anchor.getBoundingClientRect().top;
        setShowSecondaryActionBar(bottom - top > window.innerHeight);
    });
    return (React.createElement(SecondaryActionBarContext.Provider, { value: {
            setTopActionBarRef: function (refNode) {
                topBarRef.current = refNode;
            },
        } },
        children,
        React.createElement("div", { ref: anchorRef, style: { width: 1, float: 'left' } }),
        showSecondaryActionBar && (React.createElement("div", { className: wrapperClassName },
            React.createElement(ActionBarContext.Provider, { value: "secondary" },
                React.createElement(ActionBar, { deviation: deviation }),
                React.createElement(PanelPopup, { deviation: deviation, actionBarType: "secondary", className: s['large-popover-uplifted'] }))))));
};
SecondaryActionBar.displayName = 'SecondaryActionBar';
export default SecondaryActionBar;
//# sourceMappingURL=SecondaryActionBar.js.map